export default "__VITE_ASSET__ab06a9b0__"